import { render, staticRenderFns } from "./FormAttribute.vue?vue&type=template&id=249104e4&"
import script from "./FormAttribute.vue?vue&type=script&lang=js&"
export * from "./FormAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249104e4')) {
      api.createRecord('249104e4', component.options)
    } else {
      api.reload('249104e4', component.options)
    }
    module.hot.accept("./FormAttribute.vue?vue&type=template&id=249104e4&", function () {
      api.rerender('249104e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attribute/form/FormAttribute.vue"
export default component.exports